<template>
  <Photos year="2016" :min-date="1457395200" :max-date="1457740800" date-text="March 8&ndash;11" />
</template>

<script setup>
import Photos from "@/components/Photos.vue";
</script>
